// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path
				d="M6.00851064,8.25531915 C4.27234043,8.25531915 2.58723404,
					6.05957447 2.58723404,3.82978723 C2.58723404,1.42978723
					3.82978723,0.0680851064 6.00851064,0.0680851064 C8.18723404,
					0.0680851064 9.42978723,1.44680851 9.42978723,3.82978723
					C9.42978723,6.14468085 7.79574468,8.25531915 6.00851064,
					8.25531915 Z M0.10212766,13.7191489 C0.10212766,11.6255319
					0.953191489,9.00425532 3.31914894,7.93191489 C3.45531915,
					7.88085106 3.59148936,7.88085106 3.7106383,7.94893617
					C4.10212766,8.15319149 5.25957447,8.71489362 6.00851064,
					8.71489362 C6.75744681,8.71489362 7.91489362,8.17021277
					8.30638298,7.94893617 C8.44255319,7.86382979 8.59574468,
					7.86382979 8.73191489,7.94893617 C8.97021277,8.08510638
					9.34468085,8.37446809 9.87234043,8.81702128 C10.0425532,
					8.97021277 10.0765957,9.22553191 9.92340426,9.41276596
					C9.77021277,9.58297872 9.51489362,9.61702128 9.32765957,
					9.46382979 C8.91914894,9.12340426 8.64680851,8.91914894
					8.47659574,8.8 C8,9.03829787 6.87659574,9.54893617 6.00851064,
					9.54893617 C5.12340426,9.54893617 3.96595745,9.0212766
					3.50638298,8.78297872 C1.71914894,9.70212766 1.0212766,11.7276596
					0.953191489,13.3957447 C3.7106383,14.5361702 6.50212766,14.7404255
					9.25957447,14.0085106 C9.49787234,13.9574468 9.71914894,14.093617
					9.78723404,14.3148936 C9.83829787,14.5531915 9.70212766,
					14.7744681 9.48085106,14.8425532 C8.32340426,15.1489362
					7.16595745,15.3021277 6.00851064,15.3021277 C4.11914894,
					15.3021277 2.22978723,14.893617 0.357446809,14.093617
					C0.357446809,14.093617 0.340425532,14.093617 0.340425532,
					14.093617 C0.323404255,14.0765957 0.306382979,14.0765957
					0.289361702,14.0595745 C0.272340426,14.0595745 0.272340426,
					14.0425532 0.255319149,14.0425532 C0.238297872,14.0255319
					0.238297872,14.0255319 0.221276596,14.0085106 C0.204255319,
					13.9914894 0.204255319,13.9914894 0.187234043,13.9744681
					C0.187234043,13.9574468 0.170212766,13.9574468 0.170212766,
					13.9404255 C0.170212766,13.9234043 0.153191489,13.9234043
					0.153191489,13.906383 C0.153191489,13.8893617 0.136170213,
					13.8893617 0.136170213,13.8723404 C0.119148936,13.8723404
					0.119148936,13.8553191 0.119148936,13.8382979 C0.10212766,
					13.8382979 0.10212766,13.8212766 0.10212766,13.8042553
					C0.10212766,13.787234 0.10212766,13.7531915 0.10212766,
					13.7361702 C0.10212766,13.7361702 0.10212766,13.7191489 0.10212766,
					13.7191489 Z M7.69361702,10.8595745 C7.69361702,10.6212766 7.88085106,
					10.4340426 8.11914894,10.4340426 L10.4,10.4340426 L10.4,8.15319149
					C10.4,7.91489362 10.587234,7.72765957 10.8255319,7.72765957 L12.7319149,
					7.72765957 C12.9702128,7.72765957 13.1574468,7.91489362 13.1574468,
					8.15319149 L13.1574468,10.4340426 L15.4382979,10.4340426 C15.6765957,
					10.4340426 15.8638298,10.6212766 15.8638298,10.8595745 L15.8638298,
					12.7659574 C15.8638298,13.0042553 15.6765957,13.1914894 15.4382979,
					13.1914894 L13.1574468,13.1914894 L13.1574468,15.4723404 C13.1574468,
					15.7106383 12.9702128,15.8978723 12.7319149,15.8978723 L10.8255319,
					15.8978723 C10.587234,15.8978723 10.4,15.7106383 10.4,15.4723404 L10.4,
					13.1914894 L8.11914894,13.1914894 C7.88085106,13.1914894 7.69361702,13.0042553
					7.69361702,12.7659574 L7.69361702,10.8595745 Z"
				fillRule="nonzero"
			/>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Invite.js